import { apiPost } from 'api';
import { InviteConsulteeRequest, InviteConsulteeResponse } from '../../types';

export const inviteConsultee = (
  request: InviteConsulteeRequest
): Promise<InviteConsulteeResponse> =>
  apiPost<InviteConsulteeResponse, InviteConsulteeRequest>('inviteconsultee', request);
